import { Typography, Box } from "@mui/material";

export const FreeComponentsBadge = ({ count }: { count: number }) => (
  <Box sx={{ mt: 3, p: 2, bgcolor: "#222", borderRadius: 1, border: "1px solid #333" }}>
    <Typography sx={{ color: "#fff", fontSize: "0.9rem" }}>
      Select an airframe to manage its assemblies
    </Typography>
    <Typography sx={{ color: "hsl(19 101% 51% / 1)", mt: 1, fontWeight: "bold" }}>
      Free Assemblies: {count}
    </Typography>
  </Box>
);
